import type { AuthContext } from "../authContext";

export const OCI_SIGNING_KEY_SETUP =
  "In the [OCI console](https://cloud.oracle.com), open **Profile > My profile > API keys** and add an API key. Download the private key (.pem) and copy the configuration preview, which lists the tenancy OCID, user OCID, and fingerprint.";

export const ociIdentityItems = [
  {
    kind: "input",
    label: "Region",
    placeholder: "us-chicago-1",
    required: true,
    target: { kind: "configuration", field: "region" },
  },
  {
    kind: "input",
    label: "Tenancy OCID",
    placeholder: "ocid1.tenancy.oc1..…",
    required: true,
    target: { kind: "configuration", field: "tenancyOcid" },
  },
  {
    kind: "input",
    label: "User OCID",
    placeholder: "ocid1.user.oc1..…",
    required: true,
    target: { kind: "configuration", field: "userOcid" },
  },
  {
    kind: "input",
    label: "Fingerprint",
    placeholder: "aa:bb:cc:dd:…",
    required: true,
    target: { kind: "configuration", field: "fingerprint" },
  },
] as const;

export const ociPrivateKeyItem = {
  kind: "file",
  label: "Private key (.pem)",
  accept: ".pem",
  target: { kind: "secrets", field: "privateKey" },
} as const;

export function ociSigningParams(
  app: AuthContext<"tenancyOcid" | "userOcid" | "fingerprint", "privateKey">
) {
  return {
    tenancyOcid: app.config.tenancyOcid,
    userOcid: app.config.userOcid,
    fingerprint: app.config.fingerprint,
    privateKey: app.secret.privateKey,
  };
}
